import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import '../../App.css';

const MySwal = withReactContent(Swal)

const customStyles = `
  .custom-modal {
    border-radius: 24px !important;
    padding: 25px !important;
    max-width: 400px !important;
    min-width: 300px !important;
    width: 100%;
  }

  .custom-modal.success-bg {
    background: radial-gradient(circle at center, #ffffff 0%, #ffffff 50%, #F0FDF4 85%, #DCFCE7 100%) !important;
  }

  .custom-modal.error-bg {
    background: radial-gradient(circle at center, #ffffff 0%, #ffffff 50%, #FEF2F2 85%, #FEE2E2 100%) !important;
  }

  .custom-modal.warning-bg {
    background: radial-gradient(circle at center, #ffffff 0%, #ffffff 50%, #FFFBEB 85%, #FEF3C7 100%) !important;
  }

  .custom-modal.confirm-bg {
    background: radial-gradient(circle at center, #ffffff 0%, #ffffff 50%, #EFF6FF 85%, #DBEAFE 100%) !important;
  }

  .custom-modal.success-bg .swal2-actions .swal2-confirm {
    background: #10B981 !important;
    color: white !important;
  }
  .custom-modal.success-bg .swal2-actions .swal2-confirm:hover {
    background: #059669 !important;
    color: white !important;
  }
  .custom-modal.confirm-bg .swal2-actions .swal2-confirm {
    background: #3B82F6 !important;
    color: white !important;
  }
  .custom-modal.confirm-bg .swal2-actions .swal2-confirm:hover {
    background: #2563EB !important;
    color: white !important;
  }
  .custom-modal.confirm-bg .swal2-actions .swal2-cancel {
    background: #ff0000 !important;
    color: white !important;
  }
  .custom-modal.confirm-bg .swal2-actions .swal2-cancel:hover {
    background: #dc2626 !important;
    color: white !important;
  }
  .custom-modal.warning-bg .swal2-actions .swal2-cancel {
    background: #F59E0B !important;
    color: white !important;
  }
  .custom-modal.warning-bg .swal2-actions .swal2-cancel:hover {
    background: #d97706 !important;
    color: white !important;
  }

  .custom-modal .swal2-close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #5b5b5b;
    font-size: 22px;
    transition: all 0.2s;
    backdrop-filter: blur(10px);
  }

  .custom-modal .swal2-close:hover {
    background: rgba(255, 255, 255, 1);
  }

  .custom-modal .icon-wrapper {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
  }

  .custom-modal .icon-wrapper.success {
    background: linear-gradient(135deg, #D4F4E7 0%, #A8E6CF 100%);
  }

  .custom-modal .icon-wrapper.error {
    background: linear-gradient(135deg, #FFE5E5 0%, #FFCCCC 100%);
  }

  .custom-modal .icon-wrapper.warning {
    background: linear-gradient(135deg, #FFF4E5 0%, #FFE4B5 100%);
  }

  .custom-modal .icon-wrapper.confirm {
    background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  }

  .custom-modal .icon-wrapper svg {
    width: 32px;
    height: 32px;
  }

  .custom-modal .modal-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    color: #1a1a1a;
    margin: 0 0 15px 0;
  }

  .custom-modal .modal-message {
    font-size: 16px;
    color: #666;
    line-height: 1.3;
    margin-bottom: 20px;
  }

  .custom-modal .swal2-actions {
    margin: 0;
    padding: 0;
    gap: 12px;
    width: 100%;
  }

  .custom-modal .swal2-confirm,
  .custom-modal .swal2-cancel,
  .custom-modal .swal2-deny {
    margin: 0;
    padding: 14px 28px;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 600;
    border: none;
    flex: 1;
    transition: all 0.2s;
  }

  .custom-modal .swal2-confirm {
    background: #1a1a1a;
    color: white;
  }

  .custom-modal .swal2-confirm:hover {
    background: #333;
  }

  .custom-modal .swal2-cancel {
    background: #f5f5f5;
    color: #1a1a1a;
  }

  .custom-modal .swal2-cancel:hover {
    background: #e5e5e5;
  }

  .custom-modal .swal2-deny {
    background: #f5f5f5;
    color: #1a1a1a;
  }

  .custom-modal .swal2-deny:hover {
    background: #e5e5e5;
  }
`;

if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.innerHTML = customStyles;
  document.head.appendChild(styleElement);
}

class SwalServices {

  /** Confirm  */
  async Confirm(title, text, saveBtnText, cancelBtnText, html) {
    const result = await MySwal.fire({
      html: `
        <div class="icon-wrapper confirm">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
       
        <div class="modal-message">${html}</div>
      `,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: saveBtnText,
      cancelButtonText: cancelBtnText,
      customClass: {
        popup: 'custom-modal confirm-bg',
        confirmButton: 'swal2-confirm',
        cancelButton: 'swal2-cancel'
      },
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      buttonsStyling: false
    });
    if (result.isConfirmed) {
      return true;
    } else if (result.dismiss === MySwal.DismissReason.cancel) {
      return false;
    }

    return false;
  }

  async Warning(text) {
    return await MySwal.fire({
      html: `
        <div class="icon-wrapper warning">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9V13M12 17H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4L3.33975 16C2.56995 17.3333 3.53223 19 5.07183 19Z" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="modal-title">Warning</div>
        <div class="modal-message">${text}</div>
      `,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      customClass: {
        popup: 'custom-modal warning-bg',
        confirmButton: 'swal2-confirm'
      },
      showCloseButton: true,
      allowOutsideClick: true,
      buttonsStyling: false
    });
  }

  async Error(text) {
    return await MySwal.fire({
      html: `
        <div class="icon-wrapper error">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="modal-title">Error</div>
        <div class="modal-message">${text}</div>
      `,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      customClass: {
        popup: 'custom-modal error-bg',
        confirmButton: 'swal2-confirm'
      },
      showCloseButton: true,
      allowOutsideClick: true,
      buttonsStyling: false
    });
  }

  // async ErrorWithMonogram(text) {
  //   MySwal.fire({
  //     title: 'Oops!',
  //     text: text,
  //     icon: "error",
  //     iconHtml: '<span className="warnning-icons"><img src="/warningtick.png" alt=""/></span>',
  //     showCancelButton: true,
  //     allowOutsideClick: false,
  //     allowEscapeKey: true,
  //     confirmButtonColor: "#008000",
  //     cancelButtonColor: "#FF0000",
  //     confirmButtonText: `Add Monogram`,
  //     cancelButtonText: `Cancel`,
  //     // customClass: {
  //     //   confirmButton: 'my-cancel-button',
  //     //   confirmButton: 'my-cancel-button',
  //     // }

  //   });
  // }

  async ErrorWithMonogram(text, saveBtnText, cancelBtnText, html) {
    return (MySwal.fire({
      title: 'Oops!',
      text: text,
      icon: 'error',
      iconHtml: '<span className="warnning-icons"><img src="/warningtick.png" alt=""/></span>',
      showCancelButton: true,
      confirmButtonText: saveBtnText,
      cancelButtonText: cancelBtnText,
      allowOutsideClick: false,
      allowEscapeKey: true,
      html: html,
      confirmButtonColor: "#008000",
      cancelButtonColor: "#FF0000",


    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        return false;
      }
    })
    )
  }

  async Alert(text) {
    return await MySwal.fire({
      html: `
        <div class="icon-wrapper warning">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 9V13M12 17H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0377 2.66667 10.2679 4L3.33975 16C2.56995 17.3333 3.53223 19 5.07183 19Z" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="modal-title">Warning</div>
        <div class="modal-message">${text}</div>
      `,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      customClass: {
        popup: 'custom-modal warning-bg',
        confirmButton: 'swal2-confirm'
      },
      showCloseButton: true,
      allowOutsideClick: true,
      buttonsStyling: false
    });
  }

  async showLoginAlert(text) {
    MySwal.fire({
      text: text,
      icon: "warning",
      iconHtml: '<span className="warnning-icons"><img src="/warningtick.png" alt=""/></span>',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: "Login"
    }).then((result) => {
      if (result.value) {
        window.location = "/#/login" + "?redirect=" + window.location.hash
      }
    });
  }

  async Success(text) {
    return await MySwal.fire({
      html: `
        <div class="icon-wrapper success">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6L9 17L4 12" stroke="#10B981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="modal-title">Success</div>
        <div class="modal-message">${text}</div>
      `,
      showConfirmButton: true,
      confirmButtonText: "Ok",
      customClass: {
        popup: 'custom-modal success-bg',
        confirmButton: 'swal2-confirm'
      },
      showCloseButton: true,
      allowOutsideClick: true,
      buttonsStyling: false
    });
  }


  async Toaster(text) {
    MySwal.fire({
      text: text,
      toast: true,
      icon: "success",
      iconHtml: '<span className="sucess-icons"><img src="/righttike.png" alt=""/>`</span>`',
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      },
    });
  }


  async ThankYou(title, text) {
    MySwal.fire({
      title: title,
      text: text,
      icon: "info",
      iconHtml: '<span className="sucess-icons"><img src="/righttike.png" alt=""/></span>',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      customClass: {
        confirmButton: 'my-confirm-button',
      }
    });
  }

  async SuccessWithAction(text, saveBtnText) {
    return (MySwal.fire({
      title: "Success",
      text: text,
      icon: 'success',
      iconHtml: '<span className="sucess-icons"><img src="/righttike.png" alt=""/></span>',
      showCancelButton: false,
      confirmButtonText: saveBtnText,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      customClass: {
        confirmButton: 'my-confirm-button',
      }
    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        return false;
      }
    })
    )
  }

  async ErrorWithAction(text, saveBtnText) {
    return (MySwal.fire({
      title: "",
      text: text,
      icon: 'warning',
      iconHtml: '<span className="warning-body"></span><span className="warnning-icons"><img src="/warningtick.png" alt=""/></span>',
      showCancelButton: false,
      confirmButtonText: saveBtnText,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      customClass: {
        confirmButton: 'my-cancel-button',

      }
    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        return false;
      }
    })
    )
  }

  async SuccessdsWithAction(text, saveBtnText) {
    return (MySwal.fire({
      title: "",
      text: text,
      icon: 'warning',
      iconHtml: '<span className="warning-body"></span><span className="warnning-icons"><img src="/warningtick.png" alt=""/></span>',
      showCancelButton: false,
      confirmButtonText: saveBtnText,
      showCloseButton: false,
      allowOutsideClick: false,
      allowEscapeKey: true,
      customClass: {
        confirmButton: 'my-confirm-button',

      }
    }).then((result) => {
      if (result.value) {
        return true;
      } else if (result.dismiss === MySwal.DismissReason.cancel) {
        return false;
      }
    })
    )
  }
}

export default SwalServices;
